import type { Currency, ProductType } from '@skin-seoul/service';
import type React from 'react';
import type { ComponentProps, ElementType } from 'react';
import type { Link } from '@skin-seoul/design-system';

export type ProductCardProps = {
  name: string;
  brand: string;
  productImage: string;
  sku: string;
  currency: Currency;
  rating?: number;
  ranking?: number;
  reviewCount?: number;
  originalPrice: number;
  orientation?: 'vertical' | 'horizontal';
  salePrice?: number;
  theme?: 'light' | 'dark';
  children?: React.ReactNode;
  productType: ProductType;
  status?: string;
  href: string;
  productId?: string;
  category?: string[];
  /**
   * Custom Link component to use for navigation.
   * Useful for injecting Next.js Link in webapp or other routing solutions.
   * @default Link from @skin-seoul/design-system
   */
  linkComponent?: ElementType;
  /**
   * Load the product image eagerly with high fetch priority. Set it on the cards that are in the
   * first viewport of a listing (they are usually the page's LCP element); everything else stays
   * lazy. Default: lazy.
   */
  imagePriority?: boolean;
  /**
   * Analytics tracking context for button_pressed_x_added_to_cart event
   */
  analyticsTracking?: {
    button_placement: string;
    button_location: string;
  };
} & ComponentProps<typeof Link>;

// Campaign section types
export type CampaignProduct = {
  productId: string;
  name: string;
  brand: string;
  productImageUrls: string[];
  sku: string;
  currency: Currency;
  originalPrice: number;
  salePrice?: number;
  productLink: string;
};

export type ReviewStats = {
  averageRate: number;
  totalReviews: number;
};

export type CompetitorProduct = {
  price: {
    salesPrice: string | number;
  };
};

export type CampaignSectionTheme = 'light' | 'dark';
